export const ACTIONS = {
  ACCEPT_INVITATION: 'ACCEPT_INVITATION',
  ACCEPT_INVITATION_START: 'ACCEPT_INVITATION_START',
  ACCEPT_INVITATION_SUCCESS: 'ACCEPT_INVITATION_SUCCESS',
  ACCEPT_INVITATION_FAILURE: 'ACCEPT_INVITATION_FAILURE',
  RESET_ACCEPT_INVITATION: 'RESET_ACCEPT_INVITATION',
};
